import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: 'Chargement de {{label}}…',
  forbidden: 'Pas d’accès à {{label}}.',
  notFound: '{{label}} est introuvable.',
  loadingFailed: 'Échec du chargement de {{label}} : {{message}}',
  submitForbidden: 'Vous n’êtes pas autorisé à faire cela{{suffix}}',
  submitConflict: 'Cela entre en conflit avec l’état actuel{{suffix}}',
  submitGeneric: 'Une erreur est survenue : {{message}}',
};
